import { render } from "./Error404.vue?vue&type=template&id=039e4500"
const script = {}

import "./Error404.vue?vue&type=style&index=0&id=039e4500&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__